export enum ColorEnum {
  SUCCESS = 'success',
  DANGER = 'danger',
  INFO = 'info',
  WARNING = 'warning',
  PRIMARY = 'primary',
  DISABLED = 'disabled',
  TRANSPORTER = '',
}
